import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-undefined-survey",
  templateUrl: "./undefined-survey.component.html",
  styleUrls: ["./undefined-survey.component.scss"],
})
export class UndefinedSurveyComponent implements OnInit {
  @Input() survey: any;

  get logoSrc() {
    if (this.survey?.lpKey === "hummel-2" || this.survey?.lpKey === "hummel") {
      return `/assets/lp/hummel/logo.png`;
    }
    return `/assets/lp/${this.survey?.lpKey}/logo.png`;
  }

  constructor() {}

  ngOnInit(): void {}
}
